// extracted by mini-css-extract-plugin
module.exports = {"label":"InputLabel_label__R1bf_","topLabel":"InputLabel_topLabel__nrIx_"};